module.exports = "<h1 id=\"滑动输入条--d-slider\">滑动输入条  d-slider</h1>\n";